export default __webpack_public_path__ + "static/media/Calender.aa738524.svg";